import { authenticatedFetch } from './authService';

function requestedLimitFromUrl(url) {
  try {
    const baseOrigin = typeof window === 'undefined' ? 'http://localhost' : window.location.origin;
    const parsed = new URL(url, baseOrigin);
    const value = Number.parseInt(parsed.searchParams.get('limit') || '', 10);
    return Number.isFinite(value) ? value : null;
  } catch {
    return null;
  }
}

function isUnexpectedlyTruncated(payload, requestedLimit) {
  if (!payload || !Array.isArray(payload.data) || !Number.isFinite(requestedLimit)) {
    return false;
  }

  const totalAvailable = Number.isFinite(payload.totalAvailable)
    ? payload.totalAvailable
    : (Number.isFinite(payload.count) ? payload.count : payload.data.length);

  return payload.data.length < totalAvailable && payload.data.length < requestedLimit;
}

async function requestJson(url, fetchImpl) {
  const response = await fetchImpl(url);
  if (!response.ok) throw new Error(`API error: ${response.status}`);
  return response.json();
}

/**
 * Fetch the cheapest-product catalogue and self-heal one legacy failure mode:
 * older servers could return a ten-row shared cache even for limit=1000. When
 * response metadata proves that happened, retry once with noCache=true.
 */
export async function fetchCompleteCheapestProducts(url, fetchImpl = authenticatedFetch) {
  const requestedLimit = requestedLimitFromUrl(url);
  const payload = await requestJson(url, fetchImpl);

  if (!isUnexpectedlyTruncated(payload, requestedLimit)) {
    return payload;
  }

  const baseOrigin = typeof window === 'undefined' ? 'http://localhost' : window.location.origin;
  const retryUrl = new URL(url, baseOrigin);
  if (retryUrl.searchParams.get('noCache') === 'true') {
    return payload;
  }

  retryUrl.searchParams.set('noCache', 'true');
  return requestJson(retryUrl.toString(), fetchImpl);
}

export const productCatalogFetchInternals = {
  requestedLimitFromUrl,
  isUnexpectedlyTruncated,
};
